var debugtype = false;

var host = debugtype ? "http://192.168.8.30:9966/website/": "https://m.nongjike.cn/website/"; //"http://192.168.8.30:8181/manage/" ‘local.cn.utools.club’;



export default {
    host
}